// src/components/Layout.js

import React, { useState } from 'react';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaidIcon from '@mui/icons-material/Paid';
import { NavLink } from 'react-router-dom';
import Footer from './Footer';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';


const drawerWidth = 200;

const Layout = ({ children }) => {
  const theme = useTheme();

  // treat anything up through md (tablet) as "mobile-like"
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = useNavigate();
const handleLogout = () => {
  // clear any auth tokens/session
  localStorage.removeItem('authToken');
  navigate('/login', { replace: true });
};


  const handleDrawerToggle = () => {
    setMobileOpen(open => !open);
  };

  const drawerContent = (
    <>
      <Toolbar />
      <List>
        <ListItem button component={NavLink} to="/dashboard">
          <ListItemIcon><DashboardIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button component={NavLink} to="/att">
          <ListItemIcon><EventAvailableIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Attendance" />
        </ListItem>
        <ListItem button component={NavLink} to="/bill">
          <ListItemIcon><PaidIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Bill Book" />
        </ListItem>
        <ListItem button component={NavLink} to="/sales">
          <ListItemIcon><PointOfSaleIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Credit Sales" />
        </ListItem>
        <ListItem button component={NavLink} to="/customers">
          <ListItemIcon><StorefrontIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Customers" />
        </ListItem>
        <ListItem button component={NavLink} to="/sal">
          <ListItemIcon><PaidIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Salary" />
        </ListItem>
        <ListItem button component={NavLink} to="/bonus">
          <ListItemIcon><PaidIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Bonus & Penalties" />
        </ListItem>
        <ListItem button component={NavLink} to="/staff">
          <ListItemIcon><SupervisorAccountIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Staff" />
        </ListItem>
        <ListItem button component={NavLink} to="/loan">
          <ListItemIcon><AccountBalanceWalletIcon sx={{ color: theme.palette.primary.main }} /></ListItemIcon>
          <ListItemText primary="Loans" />
        </ListItem>
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Toolbar>
          {isMobileOrTablet && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
  PizzaHub AB
</Typography>
<IconButton color="inherit" onClick={handleLogout}>
  <LogoutIcon />
</IconButton>

        </Toolbar>
      </AppBar>

      {/* Drawer */}
      {isMobileOrTablet ? (
        // Temporary drawer on mobile & tablet
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      ) : (
        // Permanent drawer on larger screens
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', lg: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { lg: `${drawerWidth}px` },  // only offset on large screens
          p: 3,
          backgroundColor: '#f5f5f5',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* push content below AppBar */}
        <Toolbar />

        {/* page contents */}
        {children}

        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
